module.exports = "textarea.filled {\n  min-height: 130px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/elements/components/textarea/textarea.component.scss
// module id = ./libs/chassis-core/src/app/forms/elements/components/textarea/textarea.component.scss
// module chunks = main